// extracted by mini-css-extract-plugin
module.exports = {"currentPriceContainer":"currentPrice_currentPriceContainer__nC8vw","units":"currentPrice_units__UbQbp","change":"currentPrice_change__zZt9P"};